module.exports = __webpack_public_path__ + "fancy_flourish_frame-42f20e575087162e8476b9d1e3448217.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/fancy_flourish_frame.png
// module id = 1555
// module chunks = 1